import {
  FETCH_CAMPAIGNS,
  CREATE_CAMPAIGN,
  ADD_INSIGHTS_TO_CAMPAIGN,
  CLEAR_CAMPAIGNS_STATE,
  EDIT_CAMPAIGN,
  ADD_INSIGHT_TO_CAMPAIGN,
  CLEAR_CAMPAIGN_INSIGHTS,
  ADD_INSIGHT_TO_ADSET,
  CLEAR_ADSETS_INSIGHTS,
  ADD_INSIGHT_TO_AD,
  CLEAR_ADS_INSIGHTS,
  DELETE_CAMPAIGN
} from './mutations-types'

export default {
  [FETCH_CAMPAIGNS] (state, payload) {
    state.campaigns = payload
  },
  [CREATE_CAMPAIGN] (state, payload) {
    state.campaigns.push(payload)
  },
  [ADD_INSIGHTS_TO_CAMPAIGN] (state, payload) {
    let campaignIndex = state.campaigns.findIndex(c => c.id === payload.campaign_id)
    if (campaignIndex >= 0) Object.assign(state.campaigns[campaignIndex], payload)
  },
  [CLEAR_CAMPAIGNS_STATE] (state) {
    state.campaigns = []
    state.campaignsInsights = []
    state.adsetsInsights = []
    state.adsInsights = []
    state.currentCampaign = null
  },
  [EDIT_CAMPAIGN] (state, payload) {
    let index = state.campaigns.findIndex(c => c.id === payload.id)
    if (index >= 0) state.campaigns.splice(index, 1, payload)
  },
  [ADD_INSIGHT_TO_CAMPAIGN] (state, payload) {
    state.campaignsInsights.push(payload)
  },
  [CLEAR_CAMPAIGN_INSIGHTS] (state) {
    state.campaignsInsights = []
  },
  [ADD_INSIGHT_TO_ADSET] (state, payload) {
    state.adsetsInsights.push(payload)
  },
  [CLEAR_ADSETS_INSIGHTS] (state) {
    state.adsetsInsights = []
  },
  [ADD_INSIGHT_TO_AD] (state, payload) {
    state.adsInsights.push(payload)
  },
  [CLEAR_ADS_INSIGHTS] (state) {
    state.adsInsights = []
  },
  [DELETE_CAMPAIGN] (state, payload) {
    state.campaigns = state.campaigns.filter(c => c.id !== payload)
  }
}
